import { defineStore } from 'pinia';
import axios from 'axios';

const apiClient = axios.create({
    baseURL: '/',
    withCredentials: true, // required to handle the CSRF token
});

let pendingRequest = null;

// eslint-disable-next-line import/prefer-default-export
export const useMarkedProductsStore = defineStore('marked-products', {
    state: () => ({
        loaded: false,
        cardSeries: {},
        products: {},
    }),
    getters: {
        isMarked: (state) => (prodId) => !!state.products[prodId],
        title: (state) => (prodId) => (state.products[prodId] || [])
            .map((cardSeriesId) => `${cardSeriesId}: ${state.cardSeries[cardSeriesId] || ''}`)
            .join('\n'),
    },
    actions: {
        async load() {
            if (this.loaded) {
                return;
            }

            if (!pendingRequest) {
                pendingRequest = apiClient.get('/vue/products/marked_ids')
                    .then((response) => {
                        this.cardSeries = response.data.card_series || {};
                        this.products = response.data.products || {};
                        this.loaded = true;
                    })
                    .catch((error) => {
                        // eslint-disable-next-line no-console
                        console.error(error);
                    })
                    .finally(() => {
                        pendingRequest = null;
                    });
            }

            await pendingRequest;
        },
    },
});
